import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import PermissionViewPage from "./pages/PermissionViewPage.vue";

export const PermissionRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "permission"
) => [
  {
    name: "PermissionViewPage",
    path: prefix,
    component: PermissionViewPage,
    meta: { title: "Permission List" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.PERMISSION_VIEW
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
